import { apiService } from '@/shared/services/api/api.service';

export interface DocuSignEnvelopeResponse {
    success: boolean;
    data: {
        envelopeId: string;
        signingUrl: string;
    };
    error?: string;
    setupRequired?: boolean;
}

export interface DocuSignStatusResponse {
    success: boolean;
    data: {
        configured: boolean;
        authenticated?: boolean;
        message: string;
        missing?: string[];
        error?: string;
        setupGuide?: {
            step1: string;
            step2: string;
            step3: string;
            step4: string;
            step5: string;
            envVars: string[];
        };
    };
}

class DocuSignService {
    /**
     * Check if DocuSign is configured and authenticated
     */
    async checkStatus(): Promise<DocuSignStatusResponse> {
        const response = await apiService.get<DocuSignStatusResponse>('/docusign/status');
        return response.data;
    }

    /**
     * Create a DocuSign signing session for the specified documents
     */
    async createSigningSession(documentIds: string[]): Promise<DocuSignEnvelopeResponse> {
        const response = await apiService.post<DocuSignEnvelopeResponse>(
            '/docusign/create-envelope',
            { documentIds }
        );
        return response.data;
    }
}

export const docusignService = new DocuSignService();
